module.exports = __webpack_public_path__ + "static/media/hand-middle-finger.ac8aec4c.svg";